// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

// component
import Wysiwyg from '../../../tools/wysiwyg/Wysiwyg';

// styles
import './styles.scss';

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.object,
};

const defaultProps = {
  title: null,
  description: null,
  video: {},
};

class VideoModal extends Component {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const { title, description, video } = this.props;
    const urlPattern = {
      youtube: 'https://www.youtube.com/watch?v=',
      vimeo: 'https://vimeo.com/',
      wistia: 'https://home.wistia.com/medias/',
    };
    return (
      <div>
        {title &&
          <div className="modal__title">
            <span>
              {title}
            </span>
          </div>
        }
        {description &&
          <div className="modal__wysiwyg">
            <Wysiwyg>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Wysiwyg>
          </div>
        }
        {video.type && video.id &&
          <div className="modal__video">
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={`${urlPattern[video.type]}${video.id}`}
                width="100%"
                height="100%"
                config={{
                  youtube: {
                    playerVars: {
                      showInfo: 0,
                      rel: 0,
                      fs: 1,
                      modestbranding: 1,
                      controls: 1,
                    },
                  },
                }}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default VideoModal;



// WEBPACK FOOTER //
// ./src/app/components/layouts/modal/videoModal/VideoModal.js